

import { Box, Typography, Dialog, DialogTitle, DialogContent, useTheme, ButtonBase, Button, Stack, IconButton } from '@mui/material';

import { useState } from 'react';
import { Icon, IconSize } from '@shared/icons';
import { useAuth, useToast } from '@shared/hooks';

const Referral: React.FC = () => {
    const [open, setOpen] = useState(false);

    const { palette } = useTheme();

    const { company } = useAuth();

    const toast = useToast();

    const referralLink = () => {
        const name = company?.name?.slice(0, 3).replace(/ /g, '').toUpperCase() || '';
        const id = company?.id?.toString().slice(0, 3).replace(/ /g, '').toUpperCase() || '';
        return `${window.location.origin}/referral/${name}${id}`;
    }

    const copyUrl = () => {
        navigator.clipboard.writeText(referralLink());
        toast.success('Copied to clipboard');
    }
 
    return (
        <>
            <Stack onClick={() => setOpen(true)}
                direction="row"
                alignItems="center"
                gap={1}

                sx={{
                    backgroundColor: palette.primary.main,
                    borderRadius: '8px',
                    color: palette.common.white,
                    p: 2,
                    cursor: 'pointer',
                }}

            >
                <Icon icon="DiscountStar01" size={IconSize.SMALL} />

                <Typography variant="body2" flex={1} >
                    Refer a friend, get your next month free
                </Typography>

                <Icon icon="ChevronRight" size={IconSize.LARGE} />

            </Stack>


            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 2,
                        background: `linear-gradient(135deg, ${palette.primary.light} 0%, ${palette.primary.main} 60%)`,
                        color: palette.common.white,
                        boxShadow: 3,
                    },
                }}
            >
                <DialogTitle sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,

                    color: palette.common.white,
                }}>
                    <Icon icon="DiscountStar01" size={IconSize.LARGE} />
                    <Typography variant="h6" flex={1}>Refer a friend</Typography>

                    <IconButton onClick={() => setOpen(false)} color="inherit">
                        <Icon icon="X01" size={IconSize.LARGE} />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1, pb: 2 }}>
                    <Typography sx={{ fontSize: 16, mb: 2, fontWeight: 400 }}>
                        Share your unique referral link below! If your friend joins, your next month is on us.
                    </Typography>
                    <Box
                        sx={{
                            p: 1.5,
                            borderRadius: 2,
                            bgcolor: 'rgba(255,255,255,0.10)',
                            display: 'flex',
                            alignItems: 'center',
                            mb: 2,
                        }}
                    >

                        <Typography sx={{
                            fontSize: 14,
                            fontFamily: 'monospace',
                            flex: 1,
                            color: palette.common.white,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}>
                            {referralLink()}
                        </Typography>
                        <ButtonBase
                            sx={{
                                ml: 1,
                                borderRadius: 1,
                                px: 2,
                                py: 1,
                                bgcolor: 'rgba(255,255,255,0.18)',
                                color: palette.common.white,
                                fontWeight: 'bold',
                                fontSize: 13,
                                transition: 'background 0.2s',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.28)' },
                            }}
                            onClick={copyUrl}
                        >
                            Copy link
                        </ButtonBase>
                    </Box>

            
                </DialogContent>

            </Dialog>


        </>
    );
};

export default Referral;